var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1735 4.44714C17.4788 4.72703 17.4994 5.20146 17.2195 5.5068L8.05287 15.5068C7.91464 15.6576 7.72081 15.7454 7.51629 15.7498C7.31178 15.7543 7.11432 15.675 6.96967 15.5303L2.80301 11.3637C2.51011 11.0708 2.51011 10.5959 2.80301 10.303C3.0959 10.0101 3.57077 10.0101 3.86367 10.303L7.47644 13.9158L16.1138 4.49321C16.3937 4.18787 16.8681 4.16724 17.1735 4.44714Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.788f7a49c6727a777acafcd6b3fd3cfa.svg";
export { ForwardRef as ReactComponent };